<template>
  <div>
    <el-card class="box-card">
      <el-button type="info" @click="clickback">返回</el-button>
      <el-table :data="listlog" border stripe class="mt15">
        <el-table-column prop="Datatypes" label="数据类型" min-width="6%"></el-table-column>
        <el-table-column prop="Righteyedegree" label="球镜OD(右眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Lefteyedegree" label="球镜OS(左眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Rightcolumnmirror" label="柱镜OD(右眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Leftcolumnmirror" label="柱镜OS(左眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Rightaxial" label="轴向OD(右眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Leftaxial" label="轴向OS(左眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Nakedrighteyedegree" label="裸眼视力OD(右眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Nakedlefteyedegree" label="裸眼视力OS(左眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Nakedbinoculusdegree" label="裸眼视力OU(双眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Correctrighteyedegree" label="最佳矫正视力OD(右眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Correctlefteyedegree" label="最佳矫正视力OS(左眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Correctbinoculusdegree" label="最佳矫正视力OU(双眼)" min-width="6%"></el-table-column>
        <el-table-column prop="Interpupillary" label="瞳距" min-width="5%"></el-table-column>
        <el-table-column prop="Colorvisioninspections" label="色觉检查" min-width="5%"></el-table-column>
        <el-table-column prop="Createtime" label="录入时间" min-width="12%"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      listlog: [],
      dialogQrcode: false,
      Qrcode: null
    }
  },
  methods: {
    LoadData (parentdata) {
      this.Qrcode = parentdata.params.Qrcode
      this.apiGetMiniappShaichaVisionScreeningUserListSub()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    apiGetMiniappShaichaVisionScreeningUserListSub: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qrcode: this.Qrcode
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMiniappShaichaVisionScreeningUserListSub, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listlog = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
